import './App.css';
import './Integrations.css';
import './Invitations.css';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { SmoothScroll } from './components/StudioUI';
import Home from './pages/Home';
import Demo from './pages/Demo';
import Owner from './pages/Owner';
import Privacy from './pages/Privacy';
import PaymentReturn from './pages/PaymentReturn';
import PaymentInvitation from './pages/PaymentInvitation';

function App() {
  return <BrowserRouter><SmoothScroll /><Routes><Route path="/" element={<Home />} /><Route path="/demo/:slug" element={<Demo />} /><Route path="/owner" element={<Owner />} /><Route path="/privacy" element={<Privacy />} /><Route path="/pay" element={<PaymentInvitation />} /><Route path="/payment/return" element={<PaymentReturn />} /><Route path="*" element={<div className="simple-page container"><span className="mono">404 / A LITTLE OFF THE MAP</span><h1 data-testid="not-found-title">Let’s get you<br />back to local.</h1><Link to="/" className="studio-button" data-testid="not-found-home">Back to the studio ↗</Link></div>} /></Routes><Toaster position="bottom-right" theme="light" /></BrowserRouter>;
}

export default App;